import '../styles/Grille.css';

function GrilleCharacter({rows, characterNow}) {
    console.log('rows', rows, 'characterNow', characterNow)

    return (
		<div className="grille">
            {rows.map(({ rowsLength, id_personnage, nom_personnage, image_personnage }) => {
                return (
                    <div className="grille-row-large" key={rowsLength}>
                        <div className={`grille-cell-large ${id_personnage === characterNow.id_personnage ? 'green' : 'red'}`} >
                            <div className='grille-cell-large-detail' key={id_personnage}>
                                <span className='grille-cell-large-detail-img'><img src={`/images/characters/${image_personnage}`} alt={nom_personnage} /></span>
                                <span className='grille-cell-large-detail-nom'>{nom_personnage}</span>
                            </div>
                        </div>
                    </div>
                );
            })}
        </div>
	)
}

export default GrilleCharacter
